import styles from 'styles/Sns.module.css';
import XLogo from 'assets/images/sns/x_logo.png';
import YoutubeLogo from 'assets/images/sns/youtube_logo.png';

const Sns = () => {
  return (
    <div className={styles["sns-background"]} id="sns">
      <div className={styles["diamond1"]}></div>
      <div className={styles["diamond2"]}></div>
      <div className={styles["diamond3"]}></div>
      <div className={styles["diamond4"]}></div>
      <div className={styles["diamond5"]}></div>
      <div className={styles["diamond6"]}></div>
      <div className={styles["diamond7"]}></div>
      <div className={styles["diamond8"]}></div>
      <div>
        <div className={styles["sns-logo"]}>SNS</div>
        <div className={styles["sns-check"]}>気になった大会の最新情報を公式SNSでチェックしてみよう</div>
      </div>
      <div className={styles["sns-share-container"]}>
        <div>
          <a href="https://x.com/splatoon_zone" target="_blank" rel="noopener noreferrer">
            <img src={XLogo} className={styles["sns-x-img"]} alt="X"/>
            <p>X@splatoon_zone</p>
          </a>
        </div>
        <div>
          <a href="https://www.youtube.com/@splatzonejp" target="_blank" rel="noopener noreferrer">
            <img src={YoutubeLogo} className={styles["sns-youtube-img"]} alt="YouTube"/>
            <p>AREA CUP公式チャンネル</p>
          </a>
        </div>
      </div>
    </div>

  );
};

export default Sns;
